import React from 'react';
import {Button, Icon, Table, Form, Header, Segment, Popup, Loader, Checkbox, Grid, Select} from 'semantic-ui-react';
import axios from 'axios';
import {
    fetchAcademicYears, fetchStudentStatuses,
    fetchStudyCycle,
    fetchStudyType, fetchStudyYears,
} from '../../Lookups/util';

import ReactExport from 'react-data-export';
import ReportExcelFile from './ReportExcelFile';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from "../../util/PaginationFront";
import moment from "moment";
import {
    additionalFilterSectionStyle,
    checkboxFieldStyle,
    renderStudentIndicators,
    requiredFilterSectionStyle
} from './reportUiHelpers';

const ExcelFile = ReportExcelFile;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const getStudyTypeAndStatus = (student) => [student.studyTypeName, student.studentStatusName].filter(Boolean).join(' / ');


class StudentsWithPause extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstTimeEnrolled: false,
            moreThanOnceEnrolled: false,
            studyCycleId: null,
            studyTypeId: null,
            studyYearId: null,
            studentStatusId: null,
            studyProgramSemesterId: null,
            studyProgramBasicId: null,
            semesterId: null,
            organizationalUnitId: null,
            academicYearId: null,

            studyCycles: [],
            studyTypes: [],
            studentStatuses: [],
            studyProgramBasics: [],
            studyProgramBasicsAll: [],
            studyYears: [],
            studyProgramSemesters: [],
            studyProgramSemestersAll: [],

            semesters: [],
            academicYears: [],

            genders: [],
            gender: null,

            municipalities: [],
            filteredMunicipalities: [],
            cantons: [],
            entities: [],
            municipality: null,
            canton: null,
            entity: null,

            bihId: null,
            fbihId: null,
            rsId: null,
            bdId: null,

            students: [],
            loaded: null,
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            excelData:[],
            excludeDroppedOut: false,

            // unsa: !!((localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu')),

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.filter = this.filter.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    componentDidMount() {
        let obj = {};
        axios.post('study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName :''
                })).filter(e => e.studyProgramBasic.archived === false);

                console.log('studyProgramBasics', studyProgramBasics);

                this.setState({ studyProgramBasics, studyProgramBasicsAll: studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });

        axios.all([fetchAcademicYears(), fetchStudyCycle(), fetchStudyType(), fetchStudentStatuses(), fetchStudyYears()])
            .then(axios.spread((yearsRes, studyCycleRes, studyTypesRes, studentStatusesRes, studyYearsRes) => {
                const academicYears = yearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                })).reverse();

                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                const studyTypes = studyTypesRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                let studentStatuses = studentStatusesRes.data.filter(e=> e._key == 'regular' || e._key == 'exchange' || e._key == 'guest' || e._key == 'grad_again').map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }

                const studyYears = studyYearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));

                this.setState({
                    studyCycles, studyTypes, studentStatuses, studyYears, academicYears
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch organizationalUnits, studyCycles, languages or academicYears');
            });
    }

    handleInputChange(event, { name, value }) {
        if (value === '') {
            this.setState({
                [name]: null
            });
        }
        this.setState({
            [name]: value
        });


        if (name === 'studyCycleId') {
            if (value === null) this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll });
            this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll.filter(el => el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].id === value : null) });
        }
    }

    filter() {
        this.setState({ loaded: false, results: [], activePage: 1 });
        let obj = {
            studyCycleId: this.state.studyCycleId,
            studyProgramBasicId: this.state.studyProgramBasicId,
            excludeDroppedOut: this.state.excludeDroppedOut
        };
        console.log('obj', obj);

        axios.post(this.state.academicYearId ? `reports/students-with-pause/${this.state.academicYearId}/` : `reports/students-with-pause/0/`, { ...obj })
            .then(res => {
                console.log('res', res.data);
                this.setState({
                    students: res.data.map(el => ({ ...el, department: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName : '' })), loaded: true,
                    excelData:  res.data.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.fatherName ? el.fatherName : ''},
                        { value: el.index},
                        { value: el.studyCycleName},
                        { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: getStudyTypeAndStatus(el)},
                        { value: el.studentPause.documentDate ? moment(el.studentPause.documentDate).format('D. M. YYYY.') : ''},
                        { value: el.studentPause.documentNumber},
                        { value: el.studentPause.reason.name},
                        { value :el.studentPause.semesters ? el.studentPause.semesters.length === 1 ? el.studentPause.semesters[0].name.name + ' (' + el.studentPause.semesters[0].academicYear.name + ')' : el.studentPause.semesters.length === 2 ? 'zimski + ljetni semestar (' + el.studentPause.semesters[0].academicYear.name + ')' : '-' : '-'},
                        { value: el.studentPause.comment}
                    ]))
                });
            });
    }

    getResults(results) {
        if (results.length === 0) {
            this.setState({
                results,
                excelData: this.state.students.map(el => ([
                    {value: el.lastName},
                    {value: el.firstName},
                    {value: el.fatherName},
                    {value: el.index},
                    {value: el.studyCycleName},
                    {value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName : ''},
                    {value: el.studyProgramBasicName},
                    {value: el.studyProgramName},
                    {value: getStudyTypeAndStatus(el)},
                    {value: el.studentPause.documentDate ? moment(el.studentPause.documentDate).format('D. M. YYYY.') : ''},
                    {value: el.studentPause.documentNumber},
                    {value: el.studentPause.reason.name},
                    {value: el.studentPause.semesters ? el.studentPause.semesters.length === 1 ? el.studentPause.semesters[0].name.name + ' (' + el.studentPause.semesters[0].academicYear.name + ')' : el.studentPause.semesters.length === 2 ? 'zimski + ljetni semestar (' + el.studentPause.semesters[0].academicYear.name + ')' : '-' : '-'},
                    {value: el.studentPause.comment}
                    ]))
            });
        } else {
            this.setState({
                results,
                excelData: results.map(el => ([
                    {value: el.lastName},
                    {value: el.firstName},
                    {value: el.fatherName},
                    {value: el.index},
                    {value: el.studyCycleName},
                    {value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName : ''},
                    {value: el.studyProgramBasicName},
                    {value: el.studyProgramName},
                    {value: getStudyTypeAndStatus(el)},
                    {value: el.studentPause.documentDate ? moment(el.studentPause.documentDate).format('D. M. YYYY.') : ''},
                    {value: el.studentPause.documentNumber},
                    {value: el.studentPause.reason.name},
                    {value: el.studentPause.semesters ? el.studentPause.semesters.length === 1 ? el.studentPause.semesters[0].name.name + ' (' + el.studentPause.semesters[0].academicYear.name + ')' : el.studentPause.semesters.length === 2 ? 'zimski + ljetni semestar (' + el.studentPause.semesters[0].academicYear.name + ')' : '-' : '-'},
                    {value: el.studentPause.comment}
                ]))
            });
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.students;
    }
    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Ime oca', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Ciklus', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 250 } },
                    { title: 'Studijski program', width: { wpx: 250 } },
                    { title: 'NPP', width: { wpx: 200 } },
                    { title: 'Tip / status studenta', width: { wpx: 220 } },
                    { title: 'Datum zahtjeva', width: { wpx: 150 } },
                    { title: 'Broj zahtjeva', width: { wpx: 150 } },
                    { title: 'Razlog', width: { wpx: 250 } },
                    { title: 'Semestar', width: { wpx: 250 } },
                    { title: 'Napomena', width: { wpx: 250 } },
                ],
                data: this.state.excelData,
            }
        ];

        return (
            <div>
                <Form>
                    <Segment style={requiredFilterSectionStyle}>
                        <Header as="h4" color="blue">Obavezni parametri</Header>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Form.Dropdown
                                    label="Akademska godina"
                                    clearable
                                    placeholder="Odaberite akademsku godinu"
                                    value={this.state.academicYearId}
                                    onChange={this.handleInputChange}
                                    name="academicYearId"
                                    options={this.state.academicYears}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            <Form.Field />
                        </Form.Group>
                    </Segment>

                    <Segment style={additionalFilterSectionStyle}>
                        <Header as="h4" color="blue">Dodatni filteri</Header>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Form.Dropdown
                                    label="Ciklus studija"
                                    disabled={!this.state.academicYearId}
                                    clearable
                                    placeholder="Odaberite ciklus"
                                    options={this.state.studyCycles}
                                    onChange={this.handleInputChange}
                                    name="studyCycleId"
                                    value={this.state.studyCycleId}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown
                                    label="Studijski program"
                                    disabled={!this.state.academicYearId}
                                    clearable
                                    placeholder="Odaberite studijski program"
                                    options={this.state.studyProgramBasics}
                                    onChange={this.handleInputChange}
                                    name="studyProgramBasicId"
                                    value={this.state.studyProgramBasicId}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group inline>
                            <Form.Field style={checkboxFieldStyle}>
                                <Checkbox disabled={!this.state.academicYearId} checked={this.state.excludeDroppedOut} label="Isključi ispisane" value={this.state.excludeDroppedOut} onChange={() => this.setState({ excludeDroppedOut: !this.state.excludeDroppedOut })} />
                            </Form.Field>
                        </Form.Group>
                    </Segment>

                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button color="blue" floated="right" onClick={this.filter}>Prikaži izvještaj
                    </Button>

                </Form>
                <br /><br /><br />
                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    this.state.loaded &&
                    <div>

                        {this.state.students.length ? <Table celled selectable compact>

                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={22} >
                                        <Grid column={2} stackable>
                                            <Grid.Column width={14}>
                                                <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['organizationalUnitName', 'lastName', 'firstName', 'fatherName', 'index', 'studyProgramSemesterName', 'studyCycleName', 'studyProgramBasicName', 'department', 'studyProgramName', 'studyTypeName', 'studentStatusName', 'documentNumber']} />
                                            </Grid.Column>
                                            <Grid.Column width={2} textAlign="center">
                                                <ExcelFile filename="Studenti sa statusom mirovanja" element={<Popup
                                                    trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                        <Button.Content visible>
                                                            Excel
                                                        </Button.Content>
                                                    </Button>}
                                                    content="Preuzmi spisak u Excel-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />}>
                                                    <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Studenti" />
                                                </ExcelFile>

                                            </Grid.Column>
                                        </Grid>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell width="1">  R.br. </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={3}>Prezime (ime oca) ime</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Index </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Ciklus </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Odsjek </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Studijski program </Table.HeaderCell>
                                    {/*<Table.HeaderCell colSpan={2}> NPP </Table.HeaderCell>*/}
                                    <Table.HeaderCell colSpan={2}> Tip / status </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Datum zahtjeva </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Broj zahtjeva </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Razlog </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Semestar studija </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {currentPosts.map((el, index) =>
                                (<Table.Row key={el.id}>

                                    <Table.Cell verticalAlign="middle" width="1">  {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}. </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle" >
                                        {el.lastName} ({el.fatherName}) {el.firstName}
                                        {renderStudentIndicators(el)}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.index}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyCycleName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.department}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyProgramBasicName}</Table.Cell>
                                    {/*<Table.Cell colSpan={2} verticalAlign="middle" > {el.studyProgramName}</Table.Cell>*/}
                                    <Table.Cell colSpan={2} verticalAlign="middle" >
                                        <div>{el.studyTypeName}</div>
                                        {el.studentStatusName && <div style={{ color: '#767676', fontSize: '0.9em' }}>{el.studentStatusName}</div>}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studentPause.documentDate && moment(el.studentPause.documentDate).format('D. M. YYYY.')}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studentPause.documentNumber}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studentPause.reason.name}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studentPause.semesters ? el.studentPause.semesters.length === 1 ? el.studentPause.semesters[0].name.name + ' (' + el.studentPause.semesters[0].academicYear.name + ')' : el.studentPause.semesters.length === 2 ? 'zimski + ljetni semestar (' + el.studentPause.semesters[0].academicYear.name + ')' : '-' : '-'}</Table.Cell>
                                    {/*<Table.Cell colSpan={2} verticalAlign="middle" > {el.studentPause.comment}</Table.Cell>*/}
                                </Table.Row>))}
                            </Table.Body>
                        </Table> : 'Nema podataka.'}
                        {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </div>}

            </div>
        );
    }
}

export default StudentsWithPause;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/StudentsWithPause.js